import React from "react"
import useImage from "../../hooks/useImage"
import PropTypes from "prop-types"
import Image from "../UI/Image/Image"
import { get } from "../../helpers/utils"
import Link from "../UI/Link/Link"
import * as style from "./NewsStoryCard-tw-styles"
import Video from "../UI/Video/Video"
import variants from "../../constants/variants.constants"
import Typography from "../UI/Typography/Typography"

const NewsStoryCards = props => {
  const {
    date,
    isDateLink,
    description,
    titleLink,
    categoryLinksCollection,
    image,
    video,
    variant,
    pdfLink,
  } = props
  const styles = style[variant] || style.defaultStyle
  const hasKey = categoryLinksCollection.hasOwnProperty("items")
  let categoryArr = {}
  if (hasKey) {
    categoryArr =
      categoryLinksCollection && get(categoryLinksCollection, "items", [])
  } else {
    categoryArr = categoryLinksCollection
  }

  const { altText, foregroundImg } = useImage(image)
  return (
    <div className={styles?.contentWrpr}>
      <div className={styles?.contentLeftWrpr}>
        {image &&
          (variant === variants?.SLIDER_CARD ||
            variant === variants?.CONTACT_CARD_IMAGE) && (
            <Link url={titleLink?.url}>
              <Image
                alt={altText}
                contentfulImage={foregroundImg}
                className={styles?.imageSite}
              />
            </Link>
          )}
        {image &&
        variant !== variants?.SLIDER_CARD &&
        variant !== variants?.CONTACT_CARD_IMAGE ? (
          <Image
            alt={altText}
            contentfulImage={foregroundImg}
            className={styles?.imageSite}
          />
        ) : (
          video && (
            <Video
              {...video}
              isImageToggle={true}
              className={style?.videoWrapper}
            />
          )
        )}
        {variant === variants?.SLIDER_CARD && titleLink && (
          <div className={styles?.HeadTwo}>
            <Link {...titleLink} className={styles?.imageLinkTwo} />
          </div>
        )}
        <div className={styles?.receipeHeadingOne}>
          <div className={styles?.receipeHeadingTwo}>
            {categoryArr?.length > 0 &&
              categoryArr.map((item, index) => (
                <div key={index} className={styles?.imageLinkOne}>
                  <Link {...item} />
                  {index === categoryArr.length - 1 ? null : <span>,</span>}
                </div>
              ))}
          </div>
        </div>
      </div>

      <div className={styles?.mainHeading}>
        <div className={styles?.roundedHeading}>
          <div className={styles?.HeadOne}>
            {date && titleLink && isDateLink ? (
              <Link url={titleLink?.url}>{date}</Link>
            ) : (
              <p>{date}</p>
            )}
          </div>
          <div className={styles?.HeadTwo}>
            {variant !== variants?.SLIDER_CARD &&
              titleLink &&
              (typeof window !== "undefined" &&
              window?.location?.pathname?.includes("/news/") ? (
                <Link url={titleLink?.url}>
                  {titleLink?.label?.toUpperCase()}
                </Link>
              ) : (
                <Link {...titleLink} className={styles?.imageLinkTwo}></Link>
              ))}
            {variant !== variants?.SLIDER_CARD && pdfLink && (
              <Link
                url={pdfLink?.newLink}
                target={pdfLink?.target}
                className={styles?.imageLinkTwo}
              >
                {pdfLink?.title}
              </Link>
            )}
          </div>
          <div className={styles?.HeadThree}>
            {description && (
              <Typography
                content={description}
                className={style?.description}
                allow_br_tag={true}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

NewsStoryCards.propTypes = {
  description: PropTypes.string,
  date: PropTypes.string,
  titleLink: PropTypes.any,
  categoryLinksCollection: PropTypes.any,
  image: PropTypes.object,
  video: PropTypes.object,
  variant: PropTypes.string,
  isDateLink: PropTypes.bool,
  pdfLink: PropTypes.any,
}

export default NewsStoryCards
